import React, { useState, useEffect } from "react";
import VerticalStepper from "../AidRequest/stepper";
import AidRequestOld from "../AidRequestold/stepper";
import EmailVerification from "../AidRequestold/EmailVerification";
// import ErrorBoundary from "../ErrorBoundary";
import Logo from "../assets/idea-logo.png";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { saveAs } from "file-saver";
import MSETPDF from "../document/MSET_Educational_Scholarship_Application_Form-2.pdf";
import Axios from "axios";
import { tableData } from "../helper/TableContent";
import { useNavigate } from "react-router-dom";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  TextField,
  Button,
  Typography,
  Box,
  MenuItem,
} from "@mui/material";
import Alerts from "../helper/Alert";

const Main = () => {
  const navigate = useNavigate();
  const [condition, setCondition] = useState(null);
  const [emailverif, setEmailverif] = useState(false);
  const [data, setData] = useState();
  const [documentData, setDocumentData] = useState([]);
  const [qrOwnerId, setQrOwnerId] = useState(null);
  const [memberData, setMemberData] = useState(null);
  // New state for radio buttons and Aadhaar input
  const [hasAppliedBefore, setHasAppliedBefore] = useState(null);
  const [aadharNumber, setAadharNumber] = useState("");
  const [error, setError] = useState("");
  const [isRefererInvalid, setIsRefererInvalid] = useState(false);
  const [qrFile, setQrFile] = useState(null);
  const [qrPreview, setQrPreview] = useState(null);
  const [referer, setReferer] = useState({
    name: '',
    phone: '',
    email: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [countryCode, setCountryCode] = useState("+91");
  // const handleNew = () => {
  //   setCondition(false);
  //   setEmailverif(false);
  // };

  const getRawPhone = () => referer.phone.replace(/\D/g, "");

  const formatPhone = (value, code ) => {
    const digits = value.replace(/\D/g, "");

    if (code === "+91") {
      // 98989 98989
      if (digits.length <= 5) return digits;
      return `${digits.slice(0, 5)} ${digits.slice(5, 10)}`;
    }

    if (code === "+1") {
      // (989) 898-8989
      if (digits.length < 4) return digits;
      if (digits.length < 7)
        return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    }

    return digits;
  };

  const getStoredApplicant = () => {
    const myData = localStorage.getItem("myUsaDatastep1");
    const volunteersDetail = localStorage.getItem("volunteersDetail");

    if (myData) {
      return JSON.parse(myData);
    }

    if (volunteersDetail) {
      return JSON.parse(volunteersDetail);
    }

    return null;
  };


  const handleDownloadPdf = () => {
    saveAs(MSETPDF, "MSET_Educational_Scholarship_Application_Form-2.pdf");
  };
  const API_URL = process.env.React_App_Api;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get(`${API_URL}/website/listall`);
        setDocumentData(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [API_URL]);

  useEffect(() => {
    if (documentData.length > 0 && documentData[0].status) {
      navigate("/closed", { state: { comments: documentData[0].comments } });
    }
  }, [documentData, navigate]);


  const handleRefererSubmit = async () => {
    if (!referer.name || !referer.phone || !referer.email) {
      setAlert({
        open: true,
        message: "All referer fields are required",
        severity: "error",
      });
      return;
    }

    const formattedPhone =
      countryCode === "+91"
        ? `+91 ${getRawPhone().slice(0, 5)} ${getRawPhone().slice(5)}`
        : `+1 (${getRawPhone().slice(0, 3)}) ${getRawPhone().slice(3, 6)}-${getRawPhone().slice(6)}`;
    console.log("fp", formattedPhone);
    try {
      const response = await Axios.post(`${API_URL}/members/referchecking`, {
        name: referer.name,
        email: referer.email,
        phone: formattedPhone,
        // phone: referer.phone,
      });

      // ✅ If valid member
      if (response.data.isValid) {
        setIsSubmitted(true);

        setAlert({
          open: true,
          message: "Referer verified successfully",
          severity: "success",
        });
      }

    } catch (error) {
      const apiMessage = error?.response?.data?.message;

      // 🔴 Check backend message
      if (apiMessage === "Please enter the valid Referer Details") {
        setIsRefererInvalid(true);   // ❌ invalid
      }

      setIsSubmitted(false);

      setAlert({
        open: true,
        message:
          apiMessage ||
          "Sorry you cannot apply for this scholarship. Please enter valid refer details",
        severity: "error",
      });
    }
  };

  const handleRefererChange = (e) => {
    const { name, value } = e.target;
    setReferer((prev) => ({ ...prev, [name]: value }));
  };

  const handleAadharChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
    if (value.length <= 12) {
      setAadharNumber(value);
    }
  };

  const handleAadharSubmit = async (passedData) => {
    // Check if passedData is actual member data (not an event object)
    const verifiedMemberData = (passedData && passedData.firstName) ? passedData : memberData;

    if (aadharNumber.length !== 12) {
      setError("Aadhaar number must be 12 digits.");
      return;
    }
    try {
      const response = await Axios.get(
        `${API_URL}/aid/documents/${aadharNumber}`
      );

      // If API returns success, navigate to the form
      console.log("API Response:", response.data);
      navigate("/form", { state: { document: response.data, qrOwnerId, memberData: verifiedMemberData } });
    } catch (err) {
      console.log("ERROR", err);
      setAlert({
        open: true,
        message:
          err.response.data?.message ||
          "Something went wrong. Please try again.",
        severity: "error",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
      console.error("Error:", err);
      setError(
        err.response?.data?.message || "Something went wrong. Please try again."
      );
    }
    setError("");
    console.log("Submitted Aadhaar Number:", aadharNumber);
  };

  const handleChange = (event) => {
    setHasAppliedBefore(event.target.value);

    setReferer({
      name: '',
      phone: '',
      email: '',
    });

    // ✅ Reset submission state (very important)
    setIsSubmitted(false);
    setIsRefererInvalid(false);

    // ✅ Optional: reset Aadhaar & QR also
    setAadharNumber('');
    setQrFile(null);
    setQrPreview(null);
  };

  const [alert, setAlert] = React.useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleCloseAlert = () => {
    setAlert({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleQrUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setQrFile(file);
    setQrPreview(URL.createObjectURL(file));
  };

  const deleteApplicantData = async (applicantId) => {
    return await Axios.delete(`${API_URL}/aid/${applicantId}`);
  };


  // 🔴 VERIFY QR ONLY (NO FLOW)
  const handleVerifyQrOnly = async () => {
    if (!qrFile) {
      setAlert({ open: true, message: "Upload QR", severity: "error" });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("qr", qrFile);

      const res = await Axios.post(`${API_URL}/qr-reader/verifyQr`, formData);
      console.log("RES", res);
      setQrOwnerId(res.data.qrOwnerId);
      setMemberData(res.data.memberData);
      setCondition(false);
      setEmailverif(false);
      setAlert({
        open: true,
        message: "QR verified successfully",
        severity: "success",
      });
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "QR verification failed";

      if (message === "QR limit exceeded for this year,Please upload another QR") {
        const storedData = getStoredApplicant();
        console.log("SD", storedData);
        if (storedData) {
          try {
            const applicantId =
              storedData?.step1?.id ||
              storedData?.volunteersDetail?.id;

            if (applicantId) {
              await deleteApplicantData(applicantId);
              localStorage.removeItem("myUsaDatastep1");
              localStorage.removeItem("volunteersDetail");
            }
          } catch (deleteError) {
            console.error("Delete failed", deleteError);
          }
        }
      }

      setAlert({
        open: true,
        message,
        severity: "error",
      });
      return;
    }
  };

  //VERIFY QR + AADHAAR (YES FLOW)
  const handleVerifyQrAndAadhar = async () => {
    if (!qrFile || aadharNumber.length !== 12) {
      setAlert({
        open: true,
        message: "Upload QR and valid Aadhaar",
        severity: "error",
      });
      return;
    }

    try {
      const formData = new FormData();
      formData.append("qr", qrFile);

      const res = await Axios.post(`${API_URL}/qr-reader/verifyQr`, formData);
      setQrOwnerId(res.data.qrOwnerId);
      setMemberData(res.data.memberData);
      setAlert({
        open: true,
        message: "QR verified successfully",
        severity: "success",
      });
      handleAadharSubmit(res.data.memberData);
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "QR verification failed";

      setAlert({
        open: true,
        message,
        severity: "error",
      });
      return;
    }
  };

  return (
    <div>
      <Alerts
        open={alert.open}
        message={alert.message}
        severity={alert.severity}
        onClose={handleCloseAlert}
      />
      {condition === null && (
        <div
          style={{
            textAlign: "center",
            marginTop: "50px",
            marginBottom: "50px",
          }}
        >
          <img src={Logo} alt="logo" width={"60"} height={"60"} />
          <p style={{ fontWeight: "bold", fontSize: "20px" }}>IDEA-USA</p>
          <div
            style={{
              fontSize: "14px",
              margin: "0px",
              padding: "0px",
              marginTop: "15px",
              textAlign: "left", // Align text to the left for better readability
              marginLeft: "auto",
              marginRight: "auto",
              maxWidth: "600px", // Ensure the text is centered within the parent container
            }}
          >
            <p style={{ margin: "0px", padding: "0px" }}>
              <strong>Scholarship Application Pre-Requisite</strong>
            </p>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                margin: "0px",
                padding: "0px",
              }}
            >
              <span>Step 1: Please download MSET Scholarship Form</span>
              <span
                style={{ margin: "0 5px", fontSize: "20px", color: "#FB644F" }}
              >
                →
              </span>
              <button
                onClick={handleDownloadPdf}
                style={{
                  margin: "7px",
                  borderRadius: "3px",
                  backgroundColor: "#FB644F",
                  border: "none",
                  padding: "4px",
                  color: "white",
                  fontSize: "10px",
                  fontWeight: "bold",
                  paddingLeft: "7px",
                  paddingRight: "7px",
                  transition: "background-color 0.3s ease",
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.backgroundColor = "gray")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.backgroundColor = "#FB644F")
                }
              >
                <CloudDownloadIcon sx={{ fontSize: "15px" }} /> PDF
              </button>
            </div>
            <p style={{ marginBottom: "5px", padding: "0px" }}>
              Step 2: Fill up the form details.
            </p>
            <p style={{ marginBottom: "5px", padding: "0px" }}>
              Step 3: Sign the form.
            </p>
            <p style={{ margin: "0px", padding: "0px" }}>
              Step 4: Scan and make it ready before proceeding further.
            </p>
            <p style={{ margin: "0px", padding: "0px", marginTop: "15px" }}>
              <strong>Note:</strong> This completed form is required to be
              uploaded in the "Acknowledgment and Declaration" section while
              filling the online application.
            </p>
          </div>
          {/* <div>
            <img src="/eligibilityImg.jpg" alt="image" width="70%vw" />
          </div> */}
          <p
            style={{ marginTop: "40px", fontWeight: "bold", fontSize: "20px" }}
          >
            Scholarship
          </p>
          <table
            style={{
              marginTop: "20px",
              marginLeft: "auto",
              marginRight: "auto",
              borderCollapse: "collapse",
            }}
          >
            <thead>
              <tr>
                {tableData.map((item, index) => (
                  <th
                    key={index}
                    style={{
                      padding: "10px",
                      border: "1px solid #ddd",
                      textAlign: "left",
                    }}
                  >
                    {item.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {tableData.map((item, index) => (
                  <td
                    key={index}
                    style={{ padding: "10px", border: "1px solid #ddd" }}
                  >
                    {item.amount}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>

          {/* Question: Applied Before? */}
          <Typography variant="h6" sx={{ marginTop: "50px" }}>
            Have you applied for IDEA scholarship before?
          </Typography>

          <FormControl component="fieldset" sx={{ marginBottom: "20px" }}>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={hasAppliedBefore}
              // onChange={(e) => setHasAppliedBefore(e.target.value === 'yes')}
              onChange={handleChange}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>

          {hasAppliedBefore && (
            <Box sx={{ mt: 3, display: "flex", flexDirection: "column", alignItems: "center" }}>

              {/* ✅ Always visible */}
              <TextField
                label="Referer Name"
                name="name"
                placeholder="Enter Your Referer Name"
                value={referer.name}
                onChange={handleRefererChange}
                fullWidth
                size="small"
                disabled={isSubmitted || isRefererInvalid}
                required
                style={{ maxWidth: "300px", marginBottom: "10px" }}
                sx={{ mb: 2, }}
              />

              {/* <TextField
      label="Referer Phone"
      name="phone"
      placeholder="Enter Your Referer Phone"  
      value={referer.phone}
      onChange={handleRefererChange}
      required
      size="small"
      inputProps={{ maxLength: 15, pattern: "[0-9]*" }}
      fullWidth
      disabled={isSubmitted || isRefererInvalid}
      style={{ maxWidth: "300px", marginBottom: "10px" }}
      sx={{ mb: 2 }}
    /> */}

              <Box sx={{ display: "flex", gap: 1, maxWidth: "300px", mb: 2 }}>
                <TextField
                  select
                  value={countryCode}
                  // onChange={(e) => setCountryCode(e.target.value)}
                  onChange={(e) => {
                    const newCode = e.target.value;
                    setCountryCode(newCode);
                    //lear phone when country changes
                    setReferer((prev) => ({
                      ...prev,
                      phone: "",
                    }));
                  }}
                  size="small"
                  sx={{ width: "120px" }}
                >
                  <MenuItem value="+91">+91</MenuItem>
                  <MenuItem value="+1">+1</MenuItem>
                </TextField>

                {/* <TextField
                  label="Referer Phone"
                  name="phone"
                  placeholder="Enter phone"
                  value={referer.phone}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");

                    // India → 10 digits
                    if (countryCode === "+91") {
                      if (value.length <= 10) {
                        setReferer((prev) => ({ ...prev, phone: value }));
                      }
                    }
                    // USA → allow 10 digits also
                    else if (countryCode === "+1") {
                      if (value.length <= 10) {
                        setReferer((prev) => ({ ...prev, phone: value }));
                      }
                    }
                  }}
                  inputProps={{ maxLength: 10 }}
                  fullWidth
                  size="small"
                  disabled={isSubmitted || isRefererInvalid}
                /> */}
                <TextField
                  label="Referer Phone"
                  value={referer.phone}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/\D/g, "");

                    if (raw.length <= 10) {
                      const formatted = formatPhone(raw, countryCode);
                      setReferer((prev) => ({
                        ...prev,
                        phone: formatted,
                      }));
                    }
                  }}
                  fullWidth
                  size="small"
                />
              </Box>

              <TextField
                label="Referer Email"
                name="email"
                placeholder="Enter Your Referer Email"
                required
                size="small"
                value={referer.email}
                onChange={handleRefererChange}
                fullWidth
                disabled={isSubmitted || isRefererInvalid}
                style={{ maxWidth: "300px", marginBottom: "10px" }}
                sx={{ mb: 2 }}
              />

              {/* ✅ Submit */}
              <Button
                variant="contained"
                onClick={handleRefererSubmit}
                sx={{ mb: 3 }}
                disabled={isSubmitted || isRefererInvalid}
              >
                {isSubmitted ? "Submitted" : "Submit"}
              </Button>

              {/* ✅ Aadhaar (ONLY after submit + YES) */}
              {isSubmitted && hasAppliedBefore === "yes" && (
                <TextField
                  label="Enter your Aadhaar Number"
                  variant="outlined"
                  value={aadharNumber}
                  onChange={handleAadharChange}
                  error={!!error}
                  helperText={error}
                  inputProps={{ maxLength: 12, pattern: "[0-9]*" }}
                  fullWidth
                  style={{ maxWidth: "300px", marginBottom: "10px" }}
                />
              )}

              {/* ✅ QR Upload (ALWAYS VISIBLE but DISABLED before submit) */}
              {!qrPreview && !isRefererInvalid && (
                <Button
                  component="label"
                  variant="outlined"
                  disabled={!isSubmitted}   //key logic
                >
                  Upload QR
                  <input hidden type="file" onChange={handleQrUpload} />
                </Button>
              )}

              {qrPreview && <img src={qrPreview} width={150} alt="qr" />}

              {/* ✅ Verify Button */}
              {!isRefererInvalid && (
                <Box>
                  <Button
                    sx={{ mt: 3 }}
                    variant="contained"
                    disabled={
                      !isSubmitted ||
                      (hasAppliedBefore === "yes" && aadharNumber.length !== 12)
                    }
                    onClick={
                      hasAppliedBefore === "yes"
                        ? handleVerifyQrAndAadhar
                        : handleVerifyQrOnly
                    }
                  >
                    Verify & Continue
                  </Button>
                </Box>
              )}
            </Box>
          )}

          {isRefererInvalid && (
            <Typography color="error" sx={{ mt: 2 }}>
              Sorry you cannot apply for this scholarship. Please enter valid refer details
            </Typography>
          )}

          {/* If Yes, show Aadhaar input field */}
          {/* {hasAppliedBefore === "yes" && (
            <>
              <div style={{ marginTop: "10px" }}>
                <Box>
                  <TextField
                    label="Enter your Aadhaar Number"
                    variant="outlined"
                    value={aadharNumber}
                    onChange={handleAadharChange}
                    error={!!error}
                    helperText={error}
                    inputProps={{ maxLength: 12, pattern: "[0-9]*" }}
                    fullWidth
                    style={{ maxWidth: "300px", marginBottom: "10px" }}
                  />
                </Box>
                {!qrPreview && (
                  <Box sx={{ mt: 2 }}>
                    <Button component="label" variant="outlined">
                      Upload QR
                      <input hidden type="file" onChange={handleQrUpload} />
                    </Button>
                  </Box>
                )}

                {qrPreview && <img src={qrPreview} width={150} alt="qr" />}
                <Box>
                  <Button
                    sx={{ mt: 3 }}
                    variant="contained"
                    onClick={handleVerifyQrAndAadhar}
                  >
                    Verify & Continue
                  </Button>
                </Box>
              </div> */}

          {/* <Button
                variant="contained"
                color="primary"
                sx={{ cursor: "pointer" }}
                onClick={handleAadharSubmit}
                disabled={aadharNumber.length !== 12}
              >
                Submit
              </Button> */}
          {/* </> */}
          {/* // )} */}

          {/* {hasAppliedBefore === "no" &&
            // ((documentData.length > 0 && !documentData[0].status) ||
            //   documentData.length === 0 ? (
            //   <>
            //     <h1 style={{ fontSize: "20px", marginTop: "50px" }}>
            //       To proceed further, please click the button below
            //     </h1>
            //     <button
            //       onClick={handleNew}
            //       style={{
            //         margin: "15px",
            //         borderRadius: "3px",
            //         backgroundColor: "#1789FB",
            //         border: "none",
            //         fontWeight: "bold",
            //         padding: "5px",
            //         color: "white",
            //         fontSize: "14px",
            //         transition: "background-color 0.3s ease",
            //       }}
            //       onMouseOver={(e) =>
            //         (e.currentTarget.style.backgroundColor = "#1FA150")
            //       }
            //       onMouseOut={(e) =>
            //         (e.currentTarget.style.backgroundColor = "#1789FB")
            //       }
            //     >
            //       Apply Now
            //     </button>
            //   </>
            // ) : null)
            <Box sx={{ mt: 3 }}>
              {!qrPreview && (
                <Button component="label" variant="outlined">
                  Upload QR
                  <input hidden type="file" onChange={handleQrUpload} />
                </Button>
              )}

              {qrPreview && <img src={qrPreview} width={150} alt="qr" />}

              <Box>
                <Button
                  sx={{ mt: 3 }}
                  variant="contained"
                  onClick={handleVerifyQrOnly}
                >
                  Verify & Continue
                </Button>
              </Box>
            </Box>
          } */}
        </div>
      )}

      {/* <ErrorBoundary fallback={<p>⚠️Something went wrong</p>}> */}
      {emailverif && (
        // <ErrorBoundary>
        <EmailVerification
          setCondition={setCondition}
          setEmailverif={setEmailverif}
          setData={setData}
        />
        // </ErrorBoundary>
      )}

      {condition === true && <AidRequestOld data={data} qrOwnerId={qrOwnerId} memberData={memberData} />}
      {condition === false && <VerticalStepper qrOwnerId={qrOwnerId} memberData={memberData} />}
    </div>
  );
};

export default Main;
